import {
  defineCalculatorQuiz,
  type Answers,
  type CalculatorResult,
} from "./_schema";
import { freeTQuiz, computeDerived as freeTComputeDerived } from "./free-t";
import type { TCalcDerivedResult } from "./free-t";

/**
 * T-CALC -- second calculator-kind quiz. Thin variant of free-t with a
 * different intro framing AND single-page layout (intro + all 3 inputs +
 * one Submit button on one screen, rather than stepped one-per-screen).
 * Reuses free-t's three inputs (total-T, SHBG, albumin), branching, and
 * compute verbatim; only `slug`, `id`, `meta`, and `layout` differ.
 *
 * When inputs or compute need to diverge across calculator quizzes, extract
 * the shared bits into `quizzes/calculators/<name>.ts` per
 * `.claude/calculator-quizzes.md` (hard rule #26) -- do NOT fork
 * `vermeulen.ts` or `free-t.ts`.
 */

function compute(answers: Answers): CalculatorResult {
  return freeTQuiz.compute(answers);
}

/**
 * `computeDerived` for t-calc inherits the free-t derivation 1:1 (t-calc is a
 * meta-only variant of free-t per rule #26). Re-exported here so consumers
 * that wire to the t-calc slug have a single place to import from.
 */
export function computeDerived(answers: Answers): TCalcDerivedResult {
  return freeTComputeDerived(answers);
}

export const tCalcQuiz = defineCalculatorQuiz({
  id: "t-calc",
  slug: "t-calc",
  kind: "calculator",
  layout: "single-page",
  emailGate: true,
  meta: {
    title: "Testosterone Calculator",
    introHeadline: "How much of your testosterone is actually working?",
    introBody:
      "Most of your testosterone is locked away by SHBG and albumin -- only a fraction is free. Enter your labs to estimate yours.",
  },
  questions: freeTQuiz.questions,
  branching: freeTQuiz.branching,
  compute,
});
